import { useTranslation } from 'react-i18next'
import { Check } from 'lucide-react'
import { STEPS, type StepKey, stepIndex } from '../../lib/steps'
import { cn } from '../../lib/cn'

export function Stepper({ current }: { current: StepKey }) {
  const { t } = useTranslation()
  const currentIdx = stepIndex(current)

  return (
    <nav aria-label="progress" className="mx-auto max-w-3xl">
      <ol className="flex items-center">
        {STEPS.map((step, idx) => {
          const done = idx < currentIdx
          const active = idx === currentIdx
          return (
            <li key={step.key} className={cn('flex items-start', idx < STEPS.length - 1 && 'flex-1')}>
              <div className="flex flex-col items-center gap-1.5">
                <span
                  className={cn(
                    'flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold transition-all',
                    done && 'bg-brand-600 text-white',
                    active && 'bg-brand-600 text-white ring-4 ring-brand-500/20',
                    !done && !active && 'bg-ink-100 text-ink-400',
                  )}
                >
                  {done ? <Check className="h-4 w-4" /> : idx + 1}
                </span>
                <span
                  className={cn(
                    'hidden text-[11px] font-medium sm:block',
                    active ? 'text-ink-900' : 'text-ink-400',
                  )}
                >
                  {t(`steps.${step.key}`)}
                </span>
              </div>
              {idx < STEPS.length - 1 && (
                // Align the connector to the circle's vertical center (h-8 → 16px),
                // independent of the label height below it.
                <span
                  className={cn(
                    'mx-1.5 mt-4 h-0.5 flex-1 -translate-y-1/2 rounded-full transition-colors sm:mx-2',
                    idx < currentIdx ? 'bg-brand-600' : 'bg-ink-100',
                  )}
                />
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
